/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { SxProps, Theme } from '@mui/material';

export const productCardMediaSX: SxProps<Theme> = (theme: Theme) => ({
	marginBottom: '10px',
	mx: 'auto',
	backgroundSize: 'contain',
	position: 'relative',
	height: 'auto',
	width: '100%',
	[theme.breakpoints.down('lg')]: {
		maxHeight: '240px',
		maxWidth: '240px',
	},
});
